























































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue"
import { BTable } from 'bootstrap-vue';
import { SearchCondition, BaseSheet } from "../../modules/teacher/SumupList"

export interface Data {
  condition: SearchCondition
  baseSheets: BaseSheet[]
  fields: any[]
  currentPage: number
  perPage: number
  errors: string[]
  totalCount: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      baseSheets: new Array<BaseSheet>(),
      fields: [
        {key: "event_code", label: "イベント", sortable: true, class: 'text-center b-table-th-td'},
        {key: "sheet_code", label: "試験CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "試験名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "curriculum_id", label: "教科", sortable: true, class: 'text-center b-table-th-td'},
        {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        {key: "level", label: "VSH", sortable: true, class: 'text-center b-table-th-td'},
        {key: "misaiten_rooms", label: "未採点教室", class: 'text-center b-table-th-td'},
        {key: "aggregated_at", label: "集計日時", class: 'text-center b-table-th-td'},
        {key: "sumup", label: "", class: 'text-center b-table-th-td'},
        {key: "excel", label: "", class: 'text-center b-table-th-td'},
      ],
      currentPage: 1,
      perPage: 20,
      errors: [],
      totalCount: 0,
    });

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/sumup_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.baseSheets = response.data.base_sheet_hashes.map((x: any) => new BaseSheet(x)); 
        state.totalCount = response.data.total_count;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * 集計
     ******************************/

    const sumupAll = async (sheet_code: string, event_code: number): Promise<void> => {

      if(!window.confirm("集計処理を実行します。よろしいですか？")){
        return;
      }

      state.errors = [];
      
      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/sumup_list/sumup`, {sheet_code: sheet_code, event_code: event_code}).then(response => {
        alert(`集計処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
        window.scroll(0, 0);
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * Excelダウンロード
     ******************************/
    const download = async (base_sheet_id: string): Promise<void> => {
      
      window.location.href = `/api/sumup_list/download?base_sheet_id=${base_sheet_id}`;
    };

    /******************************
     * 集計日を画面表示文言にコンバート
     ******************************/

    const convertAggregatedAt = (date: string) => {
      return date ? moment(date).format('Y年M月D日 HH時mm分') : "-";
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.condition = new SearchCondition();
      const now = new Date();
      const year = now.getFullYear();
      // state.condition.nendo = now.getMonth() < 4 ? `${year - 1}` : `${year}`;
      await search();
    });

    return {
      ...toRefs(state),
      tableRef,
      searchClick,
      clearCondition,
      sumupAll,
      download,
      convertAggregatedAt,
      changePage,
    };
  }
});
